import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { watch, Ref } from "vue";
import { FinOneProductoAction } from "../../actions/productoActions";

export function useProductoFindOne(id: Ref<string>) {
  const queryClient = useQueryClient();



  const query = useQuery({
    queryKey: ["ProductoFindOne", id],
    queryFn: () => FinOneProductoAction(id.value),
    enabled: () => !!id.value,
    staleTime: 60 * 1000, // 1 minuto
  });

  // 🔹 Si el ID cambia, hacer prefetch del nuevo producto
  watch(id, (newId) => {
    if (newId) {
      queryClient.prefetchQuery({
        queryKey: ["ProductoFindOne", newId],
        queryFn: () => FinOneProductoAction(newId),
      });
    }
  });

  return {
    ...query, // => { data, isPending, isError, error, refetch, ... }
  };
}
